module.exports = __webpack_public_path__ + "static/media/foodprint_app9_preview.a41c2c17.jpg";